function selectChange(){
  $('form[action="/cart/add"] .select-wrapper select').not('.no-js').on('change', function() {
    const $this = $(this);
    $this.closest('.form-row').find('.option_name .selected').text($this.find('option:selected').text());
  }).trigger('change')
}

export default selectChange();



// WEBPACK FOOTER //
// ../markup/assets/js/select-change.js